import { useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import trainers from "../../data/trainers";
import PageBanner from "../../components/layout/PageBanner";
import TrainerCard from "../../components/common/TrainerCard";
import TrainerModal from "../../components/home/TrainerModal";
import "./Trainers.css";

export default function Trainers() {
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState("All");

  const specialties = useMemo(
    () => ["All", ...Array.from(new Set(trainers.map((t) => t.specialty)))],
    []
  );
  const visible = filter === "All" ? trainers : trainers.filter((t) => t.specialty === filter);

  return (
    <>
      <Helmet>
        <title>Trainers | Firm Fit Factory Peelamedu, Coimbatore</title>
        <meta name="description" content="Meet the coaching team at Firm Fit Factory — specialists in strength, functional training, weight management and personal training." />
        <link rel="canonical" href="https://www.firmfitfactory.com/trainers" />
      </Helmet>

      <PageBanner
        eyebrow="Meet The Team"
        title="Our Trainers"
        description="Coaches who correct your form, track your progress and know your goals. Profiles are placeholders pending client-confirmed details."
      />

      <section className="section trainers-page">
        <div className="container">
          <div className="trainers-page__filters" role="tablist" aria-label="Filter trainers by specialty">
            {specialties.map((s) => (
              <button
                key={s}
                type="button"
                role="tab"
                aria-selected={filter === s}
                className={`trainers-page__filter ${filter === s ? "trainers-page__filter--active" : ""}`}
                onClick={() => setFilter(s)}
              >
                {s}
              </button>
            ))}
          </div>

          <div className="trainers-page__grid">
            {visible.map((trainer) => (
              <TrainerCard trainer={trainer} onOpen={setSelected} key={trainer.id} />
            ))}
          </div>

          <div className="trainers-page__cta">
            <h2>Want a coach matched to your goal?</h2>
            <Link to="/contact" className="btn btn-primary">Book a Consultation</Link>
          </div>
        </div>
      </section>

      {selected && <TrainerModal trainer={selected} onClose={() => setSelected(null)} />}
    </>
  );
}
